export const saveUploads = resp => ({
  type: "SAVE_UPLOADS",
  payload: resp
});

export const sendUrl = resp => ({
  type: "SEND_URL",
  payload: resp
});

export const addUpload = items => ({
  type: "ADD_UPLOAD",
  items
});

export const setUploads = items => ({
  type: "SET_UPLOADS",
  items
});
export const initUploads = items => ({
  type: "INIT_UPLOADS",
  items
});
export const fetchBilltoboxUrl = resp => ({
  type: "FETCH_BILLTOBOX_URL",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/wheretobill.js